/**
 * The header's logo slot (XC-ERP1-U11 §2.2): the tenant's logo when one is
 * live, otherwise the Wingo logo. 32 px high, at most 200 px wide (140 px
 * under ``sm``), ``object-contain``. While nothing is known yet (a cold cache,
 * the read in flight) the slot holds a neutral placeholder, never the Wingo
 * logo then a swap.
 */

import { LogoIcon } from '@/components/icons';
import { useHeaderLogo, type HeaderLogoState } from '@/hooks/data/useTenantBranding';
import React from 'react';

export const BrandLogoSlot: React.FC<{ state: HeaderLogoState }> = ({ state }) => (
  <span
    data-testid="header-logo-slot"
    className="flex h-8 max-w-[140px] sm:max-w-[200px] items-center overflow-hidden"
  >
    {state.kind === 'pending' && (
      <span
        data-testid="header-logo-placeholder"
        aria-hidden="true"
        className="block h-8 w-8 rounded-md bg-white/[0.06]"
      />
    )}
    {state.kind === 'wingo' && <LogoIcon size="md" />}
    {state.kind === 'custom' && (
      <LogoIcon size="md" imageUrl={state.src} alt={state.alt} badge={state.badge} />
    )}
  </span>
);

export const HeaderLogo: React.FC = () => {
  const state = useHeaderLogo();
  return <BrandLogoSlot state={state} />;
};
